module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADCSURBVHgBpZJNCsIwEIVfUgNSEbtR6q7rbuwN7BF6BL2RJ9CzuHOnS8FFu3cjuDbPpPUHLBJjPwhhZvKYx0wAB4wHS8ah5lhlnzUJJ5zXVxBEf4i/U4utJcb9BJ40nQO1B8UKnrxtC4xcj5mmjctJWNi4Bx+ulYBUG9NoZhv7DUzTOORr6i0x8xycDoW16KLd+bhLwNsa51PmL9bSihZmA4W/WOoIP9L9h3UUswTl4ZGrbMLspGxCvTXRpc4r+azbgzuPcy8kqdl2xAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Vector.png
// module id = f1dQ
// module chunks = 14